import React, { Component } from 'react';
import { Row, Col, Table, Button } from 'reactstrap';
import { Sparkline, LineSeries, VerticalReferenceLine, HorizontalReferenceLine } from '@data-ui/sparkline';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import Meter from './Meter';
import './SidebarBlockChart.css';

const round = (number, places=1) => {
   const m = Math.pow(10, places);
   return Math.floor(number * m) / m;
}

function SparklineChart(props) {
	if (props.max !== -1 && props.usage !== '') {
		return <div className={'px-3 pt-3 pb-1 mx-3 my-1 EnergySummary clearfix ' + props.highlight}>
			<div className='EnergyType'>
				<h6 className='EnergyType-name'>{props.label}</h6>
				<p className='EnergyType-usage mb-0'>{round(props.usage*0.95, props.round).toLocaleString() === 0 ? '0 – 1' : round(props.usage*0.95, props.round).toLocaleString() + ' – ' + round(props.usage*1.05,props.round).toLocaleString()}<br />
					{props.rank >= 0 && <span className='rank'>Percentile rank: {100-props.rank<=0 ? 100 : props.rank}</span>}</p>
			</div>
			<div className='EnergySparkline pt-2'>
				<Sparkline
					ariaLabel={props.label + ': ' + props.usage}
					margin={{ top: 0, right: 2, bottom: 0, left: 2,}}
					width={240}
					height={60}
					min={0}
					max={props.chartMax*1.02}
					data={props.dist}
				>
				<LineSeries
					curve='basis'
					showArea={true}
					height={100}
					fill={props.colour}
					stroke='rgba(192,192,192,1)'
					fillOpacity={1}
				/>
				<VerticalReferenceLine 
					reference={props.index-1 < 0 ? 0 : props.index-1}
					stroke='#39b54a'
					strokeLinecap='square'
					strokeWidth={1}
				/>
				<HorizontalReferenceLine 
					reference={0}
					stroke='rgba(192,192,192,1)'
				/>
				</Sparkline>
				<div className='min'>0</div><div className='max'>{round(props.max, props.round-1).toLocaleString()}</div>
			</div>
	</div>; }
	else {return '';}
}

class SidebarBlockChart extends Component {
	
		handleZoom = () => {
			this.props.zoomOut()
		}
		
		render() {
			
		const ghg=this.props.blockDetails ? this.props.blockDetails[0].ghg: [];
		const ghgDist=this.props.blockDetails ? this.props.blockDetails[0].ghg_y.split(','): [];
		const ghgchartMax=Math.max(...ghgDist);
		const ghgIndex=this.props.blockDetails ? this.props.blockDetails[0].ghg_index : [];
		const ghgMax=this.props.blockDetails ? this.props.blockDetails[0].ghg_max : [];
		const ghgRank=this.props.blockDetails ? this.props.blockDetails[0].ghg_rank : [];
		const eui=this.props.blockDetails ? this.props.blockDetails[0].eui : [];
		const euiDist=this.props.blockDetails ? this.props.blockDetails[0].eui_y.split(','): [];
		const euichartMax=Math.max(...euiDist);
		const euiIndex=this.props.blockDetails ? this.props.blockDetails[0].eui_index : [];
		const euiMax=this.props.blockDetails ? this.props.blockDetails[0].eui_max : [];
		const euiRank=this.props.blockDetails ? this.props.blockDetails[0].eui_rank : [];
		const hydro=this.props.blockDetails ? this.props.blockDetails[0].hydro : [];
		const hydroDist=this.props.blockDetails ? this.props.blockDetails[0].hydro_y.split(','): [];
		const hydrochartMax=Math.max(...hydroDist);
		const hydroIndex=this.props.blockDetails ? this.props.blockDetails[0].hydro_index : [];
		const hydroMax=this.props.blockDetails ? this.props.blockDetails[0].hydro_max : [];
		const hydroRank=this.props.blockDetails ? this.props.blockDetails[0].hydro_rank : [];
		const gas=this.props.blockDetails ? this.props.blockDetails[0].gas : [];
		const gasDist=this.props.blockDetails ? this.props.blockDetails[0].gas_y.split(','): [];
		const gaschartMax=Math.max(...gasDist);
		const gasIndex=this.props.blockDetails ? this.props.blockDetails[0].gas_index : [];
		const gasMax=this.props.blockDetails ? this.props.blockDetails[0].gas_max : [];
		const gasRank=this.props.blockDetails ? this.props.blockDetails[0].gas_rank : [];
		const steam=this.props.blockDetails ? this.props.blockDetails[0].steam : [];
		const steamDist=this.props.blockDetails ? this.props.blockDetails[0].steam_y.split(','): [];
		const steamchartMax=Math.max(...steamDist);
		const steamIndex=this.props.blockDetails ? this.props.blockDetails[0].steam_index : [];
		const steamMax=this.props.blockDetails ? this.props.blockDetails[0].steam_max : [];
		const steamRank=this.props.blockDetails ? this.props.blockDetails[0].steam_rank : [];
		const cooling=this.props.blockDetails ? this.props.blockDetails[0].cooling : [];
		const coolingDist=this.props.blockDetails ? this.props.blockDetails[0].cooling_y.split(','): [];
		const coolingchartMax=Math.max(...coolingDist);
		const coolingIndex=this.props.blockDetails ? this.props.blockDetails[0].cooling_index : [];
		const coolingMax=this.props.blockDetails ? this.props.blockDetails[0].cooling_max : [];
		const coolingRank=this.props.blockDetails ? this.props.blockDetails[0].cooling_rank : [];
		const transportation=this.props.blockDetails ? this.props.blockDetails[0].transportation : [];
		const transportationDist=this.props.blockDetails ? this.props.blockDetails[0].transportation_y.split(','): [];
		const transportationchartMax=Math.max(...transportationDist);
		const transportationIndex=this.props.blockDetails ? this.props.blockDetails[0].transportation_index : [];
		const transportationMax=this.props.blockDetails ? this.props.blockDetails[0].transportation_max : [];
		const transportationRank=this.props.blockDetails ? this.props.blockDetails[0].transportation_rank : [];
		const water=this.props.blockDetails ? this.props.blockDetails[0].water : [];
		const waterDist=this.props.blockDetails ? this.props.blockDetails[0].water_y.split(','): [];
		const waterchartMax=Math.max(...waterDist);
		const waterIndex=this.props.blockDetails ? this.props.blockDetails[0].water_index : [];
		const waterMax=this.props.blockDetails ? this.props.blockDetails[0].water_max : [];
		const waterRank=this.props.blockDetails ? this.props.blockDetails[0].water_rank : [];
		const vintage=this.props.blockDetails ? this.props.blockDetails[0].vintage.split(',') : [];
		const category=this.props.blockDetails ? this.props.blockDetails[0].category.split(',') : [];


		return (
			<div>
				<div className='mx-3 mt-3'>
					<FontAwesomeIcon icon={faAngleLeft} /><Button color='link' onClick={this.handleZoom}>Back to District View</Button>
					<h5>Block Profile:</h5>
				</div>
				<Row className='mx-3'> 	
					<Col lg={12} xl={6}>
						<Table borderless size='sm' className='building-mix'>
							<thead>
								<tr>
									<th colspan='2'>Building Category Mix (by GFA)</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Office:</td><td className='meter'><Meter percent={category[0]} /></td>
								</tr>
								<tr>
									<td>Retail & Hospitality:</td><td className='meter'><Meter percent={category[1]} /></td>
								</tr>			
								<tr>
									<td>Multi-Unit Res:</td><td className='meter'><Meter percent={category[2]} /></td>
								</tr>
								<tr>
									<td>Residential:</td><td className='meter'><Meter percent={category[3]} /></td>
								</tr>
								<tr>
									<td>Institutional:</td><td className='meter'><Meter percent={category[4]} /></td>
								</tr>
								<tr>
									<td>Industrial:</td><td className='meter'><Meter percent={category[5]} /></td>
								</tr>	
							</tbody>
						</Table>
					</Col>
					<Col lg={12} xl={6}>
						<Table borderless size='sm' className='building-mix'>
							<thead>
								<tr>
									<th colspan='2'>Building Vintage Mix (by GFA)</th>
								</tr>
							</thead>						
							<tbody>
								<tr>
									<td>Pre-1980:</td><td className='meter'><Meter percent={vintage[0]} /></td>
								</tr>
								<tr>
									<td>1980 to 2004:</td><td className='meter'><Meter percent={vintage[1]} /></td>
								</tr>			
								<tr>
									<td>Post-2004:</td><td className='meter'><Meter percent={vintage[2]} /></td>
								</tr>
							</tbody>
						</Table>
					</Col>
				</Row>
				<h6 className='px-3'>Performance and comparison to other blocks in the District:</h6>
				<SparklineChart highlight='highlight' label='GHG from Buildings (tCO&#8322;e/year)' colour={'rgba(205,205,205,1)'} usage={ghg} dist={ghgDist} chartMax={ghgchartMax} max={ghgMax} rank={ghgRank} index={ghgIndex} round={-1} />
				<SparklineChart highlight='highlight' label='GHG from Transportation (tCO&#8322;e/year)' colour={'rgba(205,205,205,1)'} usage={transportation} dist={transportationDist} chartMax={transportationchartMax} max={transportationMax} rank={transportationRank} index={transportationIndex} round={-2} />				
				<SparklineChart highlight='highlight' label='Energy Use Intensity (kWh/m&#178;/year)' colour={'rgba(205,205,205,1)'} usage={eui} dist={euiDist} chartMax={euichartMax} max={euiMax} rank={euiRank} index={euiIndex} round={-1} />
				<SparklineChart label='Electricity (MWh/year)' colour={'rgba(252, 176, 64, 0.3)'} usage={hydro} dist={hydroDist} chartMax={hydrochartMax} max={hydroMax} rank={hydroRank} index={hydroIndex} round={-2} />
				<SparklineChart label='Natural Gas (eMWh/year)' colour={'rgba(255,0,0,0.3)'} usage={gas} dist={gasDist} chartMax={gaschartMax} max={gasMax} rank={gasRank} index={gasIndex} round={-2} />
					{steam !== 0 && <SparklineChart label='Steam (eMWh/year)' colour={'rgba(190,189,255,0.3)'} usage={steam} dist={steamDist} chartMax={steamchartMax} max={steamMax} rank={steamRank} index={steamIndex} round={-2} />}
					{cooling !== 0 && <SparklineChart label='Deep Lake Cooling (eMWh/year)' colour={'rgba(83,81,163,0.3)'} usage={cooling} dist={coolingDist} chartMax={coolingchartMax} max={coolingMax} rank={coolingRank} index={coolingIndex} round={-1} />}
				<SparklineChart label='Water (eMWh/year)' colour={'rgba(28, 163, 236,0.3)'} usage={water} dist={waterDist} chartMax={waterchartMax} max={waterMax} rank={waterRank} index={waterIndex} round={0} />
				<div className='mx-3 mt-3'>
					<p className='mx-3'><small>* Block profiles have been estimated using building energy models and building characteristics. Please see <a href="#/data-and-definitions">Data & Definitions</a> for more information about the building energy modelling.</small></p>
				</div>
			</div>	
		);
	}
}

export default SidebarBlockChart;


// WEBPACK FOOTER //
// ./src/SidebarBlockChart.js


// WEBPACK FOOTER //
// ./src/SidebarBlockChart.js